<div class="pageheader">
    <div class="page-title">
        <h1>File naming types</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'File naming types log'">
                <app-change-log-link-entity type="FilenamingType"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="container container-fixed">
    <div class="row">
        <div class="col-sm-12">

            <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='fileNamingTypes'
                [bizSetColumnChooser]="true" [bizSetAllowColumnReordering]="false" [bizSetPager]="false"
                (onInitNewRow)="onInitNewRow($event)" (onRowInserting)="onRowInserting($event)"
                (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)" [bizEditRowOnDoubleClick]="true">
                <dxo-editing mode="row" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting"></dxo-editing>

                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

                <dxi-column dataField="FilenamingTypeName" caption="Name" dataType="string" width="20%" sortOrder="asc"
                    [allowFiltering]="false">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="DistributionObjectId" caption="Document type" width="20%"
                    editCellTemplate="singleDropDownBoxEditor">
                    <dxo-lookup [dataSource]="distros" valueExpr="Id" displayExpr="Name">
                    </dxo-lookup>
                    <dxo-header-filter [dataSource]="bizGridFiltervalues.getDocumentTypeFilterData(bizGridFiltervalues.getPropertyValues(this.fileNamingTypes, 'DistributionObjectId'), distros)"/>  
                </dxi-column>

                <dxi-column dataField="FilenamingKey" caption="Key" dataType="string" [allowFiltering]="false"
                    width="25%">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="Example" caption="Example" dataType="string" [allowFiltering]="false"
                    width="25%">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="SortOrder" caption="Sort order" dataType="number" [allowFiltering]="false"
                    width="10%">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.fileNamingTypes, 'CreatedBy'))"></dxo-header-filter></dxi-column>
                <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
                <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.fileNamingTypes, 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
                <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

                <dxi-column type="buttons">
                    <dxi-button name="edit"></dxi-button>
                    <dxi-button name="delete"></dxi-button>
                    <dxi-button text="Show Log"
                                template="logTemplate"
                                [visible]="allowShowLog">
                    </dxi-button>
                </dxi-column>

                <ng-container *dxTemplate="let cell of 'logTemplate'">
                    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.FilenamingTypeName" [showIcon]="false" classNames="dx-link">
                        <app-change-log-link-entity type="FilenamingType" [id]="cell.data.FilenamingTypesId"></app-change-log-link-entity>
                    </app-change-log-link>
                </ng-container>

                <div *dxTemplate="let cellInfo of 'singleDropDownBoxEditor'">
                    <dx-drop-down-box [dropDownOptions]="dropDownOptions" [dataSource]="distros"
                        [(value)]="cellInfo.value" displayExpr="Name" valueExpr="Id"
                        contentTemplate="contentTemplate">

                        <div *dxTemplate="let e of 'contentTemplate'">
                            <dx-data-grid [dataSource]="distros" [remoteOperations]="true" [height]="250"
                                [selectedRowKeys]="[cellInfo.value]" [focusedRowEnabled]="true"
                                [focusedRowKey]="cellInfo.value" [hoverStateEnabled]="true"
                                keyExpr="Id"
                                (onSelectionChanged)="onSelectionChanged($event.selectedRowKeys, cellInfo, e.component)">
                                <dxi-column caption="Name" dataField="Name" sortOrder="asc"></dxi-column>
                                <dxi-column caption="Description" dataField="Description"></dxi-column>
                                <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                                <dxo-scrolling mode="virtual"></dxo-scrolling>
                                <dxo-selection mode="single"></dxo-selection>
                            </dx-data-grid>
                        </div>
                    </dx-drop-down-box>
                </div>

            </dx-data-grid>

        </div>
    </div>
</div>
